import { get, post } from '@/Api';
import { SelectItem } from '@/Models/Other/SelectItem';
import { Area } from "@/Models/Tables/Area";

const name = 'Area';

function getUrl(url: string) {
    return `${name}/${url}`;
}
export function getViews(): Promise<Area[]> {
    return get(getUrl("getViews"));
}
export function add(data: Area): Promise<Area> {
    return post(getUrl("add"), data);
}
export function upd(data: Area): Promise<Area> {
    return post(getUrl("upd"), data);
}
export function del(id: number): Promise<number> {
    return get(getUrl("del"), { id });
}
export function getSelectItems(): Promise<SelectItem[]> {
    return get(getUrl("getSelectItems"));
}